import { inject, Injectable } from '@angular/core';
import { HardCodedConfigService } from '@services/util/hard-coded-config.service';
import { ArrivalBookingRow } from '../models/booking-overview.model';
import { PresenceIndex } from './booking-presence.service';
import { hasPresenceWarning } from './presence-rules';

/**
 * Jelenlét-figyelmeztetés az érkezőkhöz: a küszöbóra után érzékelt jelenlét bejelentkezés nélkül.
 * Az adat a jelenlét-indexből jön (spec 6.3), külön lekérés nincs.
 */
@Injectable({
  providedIn: 'root'
})
export class PresenceWarningService {
  private readonly config = inject(HardCodedConfigService);

  markPresenceWarningLoading(row: ArrivalBookingRow): void {
    row.presenceWarningLoading = true;
  }

  applyPresenceWarning(row: ArrivalBookingRow, index: PresenceIndex): void {
    row.hasPresenceWarning = hasPresenceWarning(
      row,
      index,
      new Date(),
      this.config.PRESENCE_WARNING_HOUR_THRESHOLD,
      this.config.DEVICE_TYPE_PRESENCE_DETECTOR_ID
    );
    row.presenceWarningLoading = false;
  }
}
